// extracted by mini-css-extract-plugin
export default {"wrapper":"IA-z","viewport":"JA-z","container":"KA-z","slide":"LA-z"};